import { createSlice } from "@reduxjs/toolkit";

export interface TTeam  {
  _id:string,
  mainUserEmail: string;
  name?:string
  invitedUsers: Object[]; // references to TeamMembership or User
};
type InitGlobalState = {
  showMobileSideBar: boolean;
  userAvailableRevisions : number | null,
  hasUnsavedChanges: boolean,
  showAuthFormErrors: boolean,
    selectedTeam: TTeam | null
};

const initialState: InitGlobalState = {
  showMobileSideBar: false,
  hasUnsavedChanges: false,
  showAuthFormErrors:false,
  userAvailableRevisions:null,
  selectedTeam:null,
};

const globalSlice = createSlice({
  name: "global",
  initialState,
  reducers: {
    setShowMobileSideBar: (state, action) => {
        console.log(action);
      state.showMobileSideBar = action.payload;
    },
    setUserAvailableRevisions: (state, action) => {
      state.userAvailableRevisions = action.payload;
    },
    setShowAuthFormErrors: (state, action) => {
      state.showAuthFormErrors = action.payload;
    },

    setUnsavedChanges: (state, action) => {
      console.log('cicked');
      state.hasUnsavedChanges = action.payload;
    },
    resetUnsavedChanges: (state) => {
      state.hasUnsavedChanges = false;
    },
     // ✅ NEW: Store selected team
    setSelectedTeam: (state, action) => {
      state.selectedTeam = action.payload;
    },
    resetSelectedTeam: (state) => {
      state.selectedTeam = null;
    },
  },
});

export const { setSelectedTeam,resetSelectedTeam,setShowMobileSideBar,setShowAuthFormErrors,setUserAvailableRevisions,setUnsavedChanges,resetUnsavedChanges } = globalSlice.actions;
export default globalSlice.reducer;
